// frontend/src/hooks/useAuth.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../utils/authUtils';

export const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('ogestyle_token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('ogestyle_token');
    if (!token) {
      navigate('/login');
      return {};
    }
    return { 'Authorization': `Bearer ${token}` };
  };

  const handleUnauthorized = () => {
    logout(); // This now includes CRM widget reset
  };

  /**
   * Determine user type based on current path
   * This matches the pattern used throughout the app
   * @returns {string} 'freelancer' | 'business' | 'professional' | 'staff'
   */
  const getUserType = () => {
    const path = location.pathname;
    
    if (path.includes('/dashboard/freelancer')) {
      return 'freelancer';
    }
    if (path.includes('/dashboard/professional')) {
      return 'professional';
    }
    if (path.includes('/dashboard/professionals') || path.includes('/dashboard/staff')) {
      return 'staff';
    }
    
    // Default to business (R1 owner)
    return 'business';
  };

  return { 
    getAuthHeaders, 
    handleUnauthorized,
    userType: getUserType()
  };
};
